import { api, LightningElement } from "lwc";

// eslint-disable-next-line local/no-set-access-token-resolver
import { setAccessTokenResolver } from "@devforce/trailhead-client-auth";
import * as env from "@devforce/trailhead-client-env";
import { setLocale, Locale } from "@devforce/trailhead-client-locale";
import {
  setTrackingEnabled,
  setViewContext,
  setVisitorId,
} from "@devforce/trailhead-client-tracking";
import { ViewContextType } from "@devforce/trailhead-client-gql";
import { attrToBool } from "common/helpers";

export default class extends LightningElement {
  @api
  get accessToken() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set accessToken(value: string) {
    setAccessTokenResolver("thexternal/base", async () => {
      return value;
    });
  }

  @api
  get envApiHost() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set envApiHost(value: env.Env["API_HOST"]) {
    env.set("API_HOST", value);
  }

  @api
  get envCommunityApiHost() {
    throw new Error("EXPERIENCE_API_HOST");
  }
  set envCommunityApiHost(value: env.Env["COMMUNITY_API_HOST"]) {
    env.set("COMMUNITY_API_HOST", value);
  }

  @api
  get envExperienceApiHost() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set envExperienceApiHost(value: env.Env["EXPERIENCE_API_HOST"]) {
    env.set("EXPERIENCE_API_HOST", value);
  }

  @api
  get locale() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set locale(value: Locale) {
    setLocale(value);
  }

  @api
  get trackingDisabled() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set trackingDisabled(value: string | boolean | null) {
    setTrackingEnabled(!attrToBool(value));
  }

  @api
  get trackingVisitorId() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set trackingVisitorId(value: string) {
    setVisitorId(value);
  }

  @api
  trackingViewContext: ViewContextType | null = null;

  connectedCallback() {
    setViewContext(this.trackingViewContext);
  }
}
